export default __webpack_public_path__ + "static/media/close.8588568d.png";